// Grupo de chips multiselección con "Otro" + campo "Especifica cuál" (comportamiento del HTML final).
export const ChipGroup = ({ options, value, onChange, other, onOther, testId, withOtherChip = true, exclusive }) => {
  const sel = value || [];
  const toggle = (v) => {
    if (exclusive && v === exclusive) return onChange(sel.includes(v) ? [] : [v]);
    const base = sel.filter((x) => x !== exclusive);
    const next = base.includes(v) ? base.filter((x) => x !== v) : [...base, v];
    onChange(next);
    if (v === "Otro" && !next.includes("Otro")) onOther("");
  };
  return (
    <div className="onb-chips" data-testid={testId}>
      {[...options, ...(withOtherChip ? ["Otro"] : [])].map((o) => (
        <button key={o} type="button" className={`onb-chip ${sel.includes(o) ? "selected" : ""}`} aria-pressed={sel.includes(o)} onClick={() => toggle(o)} data-testid={`${testId}-${o}`}>{o}</button>
      ))}
      {withOtherChip && sel.includes("Otro") && (
        <input className="onb-other-input" placeholder="Especifica cuál" value={other || ""} onChange={(e) => onOther(e.target.value)} data-testid={`${testId}-other-input`} />
      )}
    </div>
  );
};
